<template>
  <div class="words">
    <div class="box" @click="input">
      <div class="keyword">
        <el-tag
          v-show="keyword.length > 0"
          v-for="(tag, index) in keyword"
          size="mini"
          :key="index"
          @close="close(index)"
          :closable="!checkIF">
          <span @click="tagEdit(tag, index)">{{tag}}</span>
        </el-tag>
      </div>
      <el-input
        :disabled="checkIF"
        ref="input"
        type="text"
        @keyup.enter.native="search"
        @blur="search"
        placeholder="请输入关键词并回车"
        v-model.trim="text"
        show-word-limit
      />
    </div>
  </div>
</template>
 
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    checkIF: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: '',
      keyword: []
    }
  },
  watch: {
    list() {
      this.keyword = this.list
    },
  },
  methods: {
    tagEdit(tag, index) {
      this.text = tag
      this.keyword.splice(index, 1)
      this.$emit('inputKeyword', this.keyword)
    },
    input() {
      this.$refs.input.focus()
    },
    search() {
      if (this.text) {
        this.keyword.push(`${this.text}`)
        this.text = ''
        this.$emit('inputKeyword', this.keyword)
      }
    },
    close(index) {
      this.$emit('tagEdit',  this.keyword[index])
      this.keyword.splice(index, 1)
      this.$emit('inputKeyword', this.keyword)
    }
  }
}
</script>
 
<style lang="scss" scoped>
.words{
  height: 96px;
  background: #FFFFFF;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #E5E6EB;
  position: relative;
  padding: 7px 16px;
  z-index: 10;
  .title {
    font-size: 14px;
    color: #86909C;
    .icon {
      cursor: pointer;
      margin-left: 5px;
    }
  }
  ::v-deep .box {
    height: 100%;
    .keyword {
      font-size: 14px;
      color: #C9CDD4;
      max-height: calc(100% - 30px);
      &::-webkit-scrollbar {
        width: 0;
      }
      overflow: auto;
      .el-tag {
        font-size: 14px;
        margin-bottom: 5px;
        margin-right: 5px;
      }
    }
    .el-input__inner {
      border: none;
      height: 30px;
    }
  }
}
</style>